import {IMessagesList} from "./notification.types";

export const defaultNotificationState: IMessagesList = {
  messages: [],
  loadingMessages: [],
};
